import { Button, Card, CardBody, CardHeader, Collapse } from "reactstrap";
import React, { useState } from "react";

import { DOWNLOADABLE_FILE_CATEGORIES } from "../../constants";
import DownloadFilesDrawer from "../../components/downloads/DownloadFilesDrawer";
import PropTypes from "prop-types";
import { hasBackofficeAccess } from "../../services/roles";
import { statTable } from "../../uploadsessions/uploadSessionModal";

export default function DatasetTable({ statistics, uploadSession, user }) {
  const [isOpen, setIsOpen] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);

  const hasDownloadableFiles = statistics?.some((s) =>
    DOWNLOADABLE_FILE_CATEGORIES.includes(s.category)
  );
  const canDownload = hasDownloadableFiles && hasBackofficeAccess(user?.self);

  return (
    <>
      <Card className="mt-3">
        <CardHeader
          className="d-flex align-items-center justify-content-between bg-white"
          style={{ cursor: "pointer" }}
          onClick={() => setIsOpen((v) => !v)}
        >
          <span className="d-flex align-items-center gap-2 fw-bold green-color">
            <i
              className="fa-solid fa-chevron-down"
              style={{
                transition: "transform 0.2s ease",
                transform: isOpen ? "rotate(0deg)" : "rotate(-90deg)",
              }}
            />
            Previous Datasets
          </span>
          {canDownload && (
            <Button
              color="primary"
              size="sm"
              onClick={(e) => {
                e.stopPropagation();
                setDrawerOpen(true);
              }}
            >
              <i className="fa-solid fa-download me-1" />
              Download files
            </Button>
          )}
        </CardHeader>
        <Collapse isOpen={isOpen}>
          <CardBody className="py-2">{statTable(statistics)}</CardBody>
        </Collapse>
      </Card>

      {drawerOpen && (
        <DownloadFilesDrawer
          fixed
          statistics={statistics}
          uploadSession={uploadSession}
          onClose={() => setDrawerOpen(false)}
          user={user}
        />
      )}
    </>
  );
}

DatasetTable.propTypes = {
  statistics: PropTypes.array,
  uploadSession: PropTypes.object,
  user: PropTypes.object,
};
